import PropTypes from 'prop-types'
import React from 'react'
import Link from 'components/Link'
import cx from 'classnames'

import classes from './Dropdown.scss'

import mediaQueryMatches from 'helpers/mediaQuery'

import Button from 'components/Button'

import Popover from 'material-ui/Popover'
import Menu from 'material-ui/Menu'
import MenuItem from 'material-ui/MenuItem'
import NavigationExpandMore from 'material-ui/svg-icons/navigation/expand-more'
import NavigationMenu from 'material-ui/svg-icons/navigation/menu'

export class Dropdown extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      open: false,
      isMobile: false
    }

    this.anchor = null
  }

  componentDidMount () {
    if (this.props.mobileHamburger || this.props.mobileOnly) {
      window.addEventListener('resize', this.handleResize)
      this.handleResize()
    }
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.handleResize)
  }

  setOpen = open => {
    this.setState({ open })
  };

  handleAnchorClick = e => {
    e.preventDefault()
    this.setState({ open: !this.state.open })
    this.anchor = e.currentTarget // faster than setState and doesn't bubble stuff
  };

  show = () => {
    this.setState({ open: true })
  };

  hide = () => {
    this.setState({ open: false })
  };

  handleResize = () => {
    const matches = mediaQueryMatches('medium', 'max') // NOTE: Matches can be undefined, which means it had an error

    if (matches) {
      this.setState({ isMobile: true })
    } else {
      this.setState({ isMobile: false })
    }
  };

  shouldShowHamburger = () => {
    return this.state.isMobile && this.props.mobileHamburger
  };

  getClassName = () => {
    return cx(this.props.className, classes.dropdown, {
      [classes.open]: !!this.state.open && classes.open,
      [classes['mobile-only']]: !!this.props.mobileOnly && classes['mobile-only']
    })
  };

  render () {
    return <div className={this.getClassName()}>
      <Button
        options={['transparent']}
        callback={this.handleAnchorClick}
        onlyOnce={false}
      >
        {!this.shouldShowHamburger() && this.props.name}

        <i className={cx(classes.icon, this.shouldShowHamburger() && classes.hamburger)}>
          {this.shouldShowHamburger() && <NavigationMenu /> || <NavigationExpandMore />}
        </i>
      </Button>

      <Popover
        animated
        className={classes.popover}
        open={this.state.open}
        anchorEl={this.anchor}
        anchorOrigin={{horizontal: 'right', vertical: 'top'}}
        targetOrigin={{horizontal: 'right', vertical: 'top'}}
        onRequestClose={this.hide}
      >
        <Menu style={{maxHeight: '50vh'}}>
          {this.props.menuItems.map((obj, index) => {
            if (React.isValidElement(obj)) return obj // allows to inject something like a

            let callback = (e) => {
              this.hide()
              if (obj.onClick && typeof obj.onClick === 'function') {
                if (obj.onClick(e) === false) return false // passed onClick returned false
                if (e.defaultPrevented) return false // default has been prevented on this event
              }
            }

            return <MenuItem
              primaryText={obj.name}
              containerElement={<Link callback={callback} to={obj.to || obj.href} title={obj.title || obj.name} />}
              key={index}
            />
          })}
        </Menu>
      </Popover>
    </div>
  }
}

Dropdown.propTypes = {
  name: PropTypes.string,
  className: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.array,
    PropTypes.string
  ]),
  mobileOnly: PropTypes.bool,
  mobileHamburger: PropTypes.bool,
  menuItems: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.node
    ])
  ),
  selectedIndex: PropTypes.any
}

Dropdown.defaultProps = {
  mobileOnly: false,
  mobileHamburger: false
}

export default Dropdown



// WEBPACK FOOTER //
// ./src/components/Dropdown/Dropdown.js